<template>
  <LayoutLegal>
    <h2>Terms of Use</h2>
    <p>
      The following Terms of Use govern your access to and use of this Whale
      Member websites (the “Site”). They additionally govern your membership to
      the Site and your license to view the content (the “Content”) on the Site.
      Please review them carefully prior to accessing, using, or joining the
      Site. Do not access, use, or join the Site if you do not agree to comply
      with and be bound by each of every term contained in these Terms of Use.
      If you have any questions following your review of these Terms of Use or
      do not understand any provisions of these Terms of Use, please contact us
      at cvv@cvvhelp.net or consult an attorney.
    </p>
    <h3>1. Contract</h3>
    <p>
      These Terms of Use constitute a binding contract between you and Whale
      Member (“Whale Member” or “WM”).
      <br />
      <br />
      a. The consideration you provide to WM is your agreement to consent to and
      be bound by each and every provision of these Terms of Use.
      <br />
      b. The consideration WM provides to you is permission to access and use,
      under a limited license, the intellectual property found on and
      distributed through Whale Member Site.
      <br />
      c. By accessing, using, or joining this Site, you expressly agree that
      there is sufficient consideration to form a binding agreement between WM
      and you.
    </p>
    <h3>2. Revisions</h3>
    <p>
      WM reserves the unilateral right to modify these Terms of Use from
      time-to-time.
      <br />
      <br />
      <strong>a.</strong>
      By accessing, using, or joining this Site, you acknowledge that WM
      possesses this unilateral right and that you are never permitted to revise
      these Terms of Use and that you will ensure that you stay up-to-date
      regarding changes to these Terms of Use by checking them on a regular
      basis.
      <br />
      <strong>b.</strong>
      Dates that the Terms of Use are revised will be contained in the “Last
      Modified Date” on the top of this page. Additionally, the revisions to the
      Terms of Use will be listed on the top of this page. If you visit this
      page and see a new “Last Modified Date,” you agree that you shall review
      the Terms of Use for revisions.
      <br />
      <strong>c.</strong>
      After revisions are made and posted, if you continue to use the Site, this
      is your acknowledgement of your obligation to comply with the revisions to
      this Agreement, and your recognition that we will comply with the
      revisions as well. However, if you cease using the Site upon the
      publication of new Terms of Use, your relationship with WM will continue
      to be controlled by the previous version of the Terms of Use.
      <br />
      <strong>d.</strong>
      If you fail to review these Terms of Use on a regular basis or disregard
      any messages that WM sends you regarding revisions to these Terms of Use,
      you assume any and all liability for your failure to do so.
    </p>
    <h3>3. The Site&#39;s Content</h3>
    <p>
      The Site contains audiovisual and photographic adult entertainment
      protected as WM’s intellectual property.
      <br />
      <br />
      <strong>a.</strong>
      By using, accessing, or joining the Site, you acknowledge that you are
      aware of the Site’s content, that you are not offended by the Site’s
      content, and that you are accessing the Site freely, voluntarily, and
      willingly.
      <br />
      <strong>b.</strong>
      You additionally acknowledge that viewing pornography is not unlawful or
      illegal in the jurisdiction where you reside or where you are viewing the
      Content.
      <br />
      <strong>c.</strong>
      You acknowledge that the Content is expressive and is fully protected by
      the First Amendment to the Constitution of the United States and Article
      10 of the European Convention on Human Rights.
      <br />
    </p>
    <h3>4. Age of Majority</h3>
    <p>
      In order to use view or access the intellectual property on the Site you
      must have reached the age of majority in the jurisdiction where you
      reside.
    </p>
    <h3>5. Intellectual Property</h3>
    <p>
      This Site contains WM’s intellectual property or intellectual property
      that WM has a license to display.
      <br />
      <br />
      <strong>a. Copyright.</strong>
      This Site belongs to WM. WM claims copyright protection for the Content on
      the Site or, alternatively, WM is permitted by the copyright owner to
      display the content on the Site. When you access or view the Content on
      the Site, you do so through a personal, non-exclusive, non-transferable,
      limited, and revocable license subject to these Terms of Use.
      <br />
      <strong>b. License.</strong>
      Your license to view the Content on the Site is personal to you. You will
      not share the Content with any third party, including but not limited to
      by email transmission, hosting or sharing them on a remote server, or
      placing them on a tube site, torrent site, or file locker site. If you are
      a member in good-standing of the Site, you are permitted to cache the
      materials on a single computer or connected mobile device for your own
      personal, non-commercial, and internal use.
      <br />
      <strong>c. Trademark.</strong>
      WHALE MEMBER and the name of this Site are trademarks and/or service marks
      belonging to WM. You are not permitted to and shall not use any
      confusingly similar name or mark for related goods and services, including
      as an Internet domain name.
      <br />
      <strong>d. Third Party Trademark.</strong>
      Trademarks or product and service names of third parties may be referenced
      on this Site. If so, they are the exclusive property of those third
      parties. Do not use those third party trademarks without the express
      permission of those third parties.
      <br />
      <strong>e. Infringement.</strong>
      <span>You</span>
      <em>expressly agree</em>
      <span>that your license to view these materials transfers</span>
      <em>no title nor intellectual property rights to you</em>
      <span>and that you have</span>
      <em>
        no title nor intellectual property rights to the Content on the Site.
      </em>
      Infringement of WM’s intellectual property may result in legal action
      against you for damages, including statutory damages, actual damages,
      punitive damages, attorneys’ fee damages, and injunctive relief.
      <br />
    </p>
    <h3>6. Restrictions on Use</h3>
    <p>
      Absent WM’s
      <em>express written permission</em>
      , you shall not engage in any of the following activities:
      <br />
      <br />
      <strong>a.</strong>
      Sharing the Content with third parties, including but not limited to, on
      porn tube sites, in file lockers, or in bit torrent swarms, or any other
      similar technology.
      <br />
      <strong>b.</strong>
      Duplicating any portion of the Site or the Content on the Site.
      <br />
      <strong>c.</strong>
      Publicly displaying the Site or any of the Content on the Site.
      <br />
      <strong>d.</strong>
      Creating derivative works with regards to any of the Content on the Site.
      <br />
      <strong>e.</strong>
      Remove any proprietary notices, including copyright and trademark notices
      and watermarks, from any of the intellectual property on the Site.
      <br />
      <strong>f.</strong>
      Using the intellectual property on the Site for anything other than
      personal, non-commercial use without express permission, including as a
      competitor, as a member of a local or federal law enforcement officer,
      government employee, or as an agent of the aforementioned.
      <br />
    </p>
    <h3>7. Membership</h3>
    <p>
      While WM grants anyone willing to abide by each and every provision of
      these Terms of Use a limited, non-exclusive, revocable, non-transferrable
      license to view the public areas of the Site, you must become a member of
      the Site to obtain a limited, non-exclusive, revocable, non-transferrable
      license to the non-public areas of the Site. You are only permitted to
      access the non-public areas of the Site if you are a member in good
      standing.
      <br />
      <br />
      <strong>a. Registration.</strong>
      You become a member of the Site by submitting an online registration form.
      The benefits that members to the Site receive will be explained on the
      registration page at the time of registration; those benefits may change
      from time-to-time. When you register for the Site, you are required to
      provide us with complete and accurate personal information (“Registration
      Data”). If your Registration Data changes (e.g., your address, credit
      card, email), you are required to update it immediately by contacting us
      at cvv@cvvhelp.net.
      <br />
      <strong>b. Username and Password.</strong>
      When you register for the Site, you will receive a username and password.
      You agree to do everything in your power to ensure these stay secure. In
      the event that your password security is breached, WM is not liable for
      damage or liability arising therefrom. You will be solely liable for any
      consequences of the breach.
      <br />
      <strong>c. Term.</strong>
      WM offers differing membership periods, which automatically renew (unless
      otherwise noted on the registration page) until terminated.
      <br />
      <strong>d. Voluntary Termination.</strong>
      You may voluntarily terminate your membership at any time by following the
      cancellation instruction at the footer of this website. If you voluntarily
      terminate your membership, your membership will end when your membership
      period expires. If you fail to terminate your registration within 48 hours
      of a renewal period, your membership may be renewed for an additional
      period, which WM will bill you for.
      <br />
      <strong>e. Involuntary Termination.</strong>
      WM reserves the right to terminate your membership at any time, with or
      without advance notice. If WM involuntarily terminates your membership, it
      will terminate immediately, and you will not be entitled to reimbursement
      for the remainder of your membership term. Involuntary termination may
      occur if: (i) we are unable to authenticate the accuracy of any
      information you provided to WM; (ii) we believe that you have breached any
      material term of these Terms of Use or any documents incorporated by
      reference; (iii) your actions may cause legal liability for you, WM, or
      other members to the Site; or (iv) WM ceases operations.
      <br />
      <strong>f. Liability.</strong>
      You agree that WM shall never be liable for terminating your membership.
      <br />
      <strong>g. Re-registration.</strong>
      If you voluntarily terminate your membership, you may re-register as a
      user of the Site at any time, provided that you agree to the applicable
      Terms of Use. If WM involuntarily terminates your membership, you agree
      that you will not attempt to re-register to the Site without WM’s express
      written consent.
      <br />
      <strong>h. Email.</strong>
      When you register for the Site, you will receive unsolicited commercial
      email from WM or its partners and agents. When your account is terminated
      (whether voluntarily or involuntarily), you consent to continue to receive
      these unsolicited emails until you terminate it by opting out.
      <br />
    </p>
    <h3>8. Dispute Resolution</h3>
    <p>
      <strong>a. Governing Law.</strong>
      These Terms of Use, and all matters arising out of or in any way related
      to these Terms of Use, shall be governed by the laws of the State of
      Nevada, excluding any conflict of law provisions. Through your use of this
      Site, you agree that, without exception, any and all disputes between
      Whale Member and you will be adjudicated in Clark County, Nevada. However,
      if you are a user who resides in the European Union, then the Terms of Use
      shall be governed by UK law.
      <br />
      <strong>b. Complaint Policy and Settlement Discussions.</strong>
      If you have any complaints with regard to any Content on the Site, Whale
      Member’s maintenance of the Site, or your use of the Site, you shall email
      Whale Member at cvv@cvvhelp.net and fully describe the nature of that
      complaint. Whale Member shall respond within 7 days of receipt of the
      email regarding its view of the merits of your complaint and possible
      resolution. Once you have submitted a complaint, the parties shall be
      deemed to have entered settlement discussions, and no formal adversarial
      process shall initiate until Whale Member informs you that it has given
      you its final response.
      <br />
      <strong>c. Arbitration.</strong>
      Any controversy or claim arising out of or relating to these Terms of Use
      in any way or any user’s or member’s use of the Site or viewing of the
      Content shall be settled by binding arbitration. The arbitration shall be
      conducted by an independent contractor located in Clark County, Nevada and
      shall under no circumstances be conducted through JAMS or the American
      Arbitration Association (“AAA”), or by any retired federal or state judge,
      or by any arbitrator listed in AAA’s or JAMS’ list of neutrals. For
      clarity, any arbitrator associated in any way with JAMS or AAA has no
      power to resolve any dispute related in any way to these Terms of Use
      unless both parties agree in writing to a waiver of this prohibition. Any
      such controversy or claim shall be arbitrated on an individual basis and
      shall not be consolidated with the arbitration of any other party. The
      arbitration shall be conducted in Clark County, Nevada, and judgment on
      the arbitration award may be entered in any state or federal court in
      Nevada having jurisdiction thereof. Whale Member may terminate this
      agreement to arbitrate at its sole discretion, but such shall not be
      effective with regard to disputes of which Whale Member had actual notice
      on the date of termination.
      <br />
      <strong>d. Injunctive Relief.</strong>
      Any party seeking temporary, preliminary, or permanent injunctive relief
      may do so in the state and federal courts located in Clark County, Nevada.
      <br />
      <strong>e. Venue.</strong>
      Except as provided in Paragraphs 8(b) and (c) above, the state and federal
      courts located in Clark County, Nevada shall be the exclusive forum and
      venue to resolve disputes arising in any way out of these Terms of Use or
      related to any user’s use of the Site or viewing of the Content.
      <br />
      <strong>f. Personal Jurisdiction.</strong>
      By using the Site, and thereby consenting to be bound by these Terms of
      Use, users consent to personal jurisdiction in the State of Nevada with
      regard to all disputes pertaining to these Terms of Use or the user’s use
      of the Site. You further agree that the Site is passive and does not give
      rise to personal jurisdiction over Whale Member, whether specific or
      general, in any jurisdiction other than the State of Nevada.
      <br />
      <strong>g. Statute of Limitations.</strong>
      Whale Member and you agree that any cause of action arising out of these
      Terms of Use and the associated license must commence within 1 year of the
      date that the cause of action accrues, else it shall be permanently
      barred.
      <br />
      <strong>h. Attorneys&#39; Fees and Costs.</strong>
      In the event that any dispute arises under these Terms of Use, the parties
      shall bear their own attorneys’ fees and costs, regardless of which party
      prevails in the dispute.
      <br />
      <strong>i. Service of Process.</strong>
      With regard to any dispute between WM and you, regardless of the subject
      matter, WM and you stipulate that service of process may occur via email,
      U.S. mail, or facsimile in order to avoid the hassle and expense of
      traditional service of process. Personal service of process shall not be
      required, and the parties expressly waive their right to traditional
      service of process. Email service shall be effective if Whale Member
      serves the email address that you provided in your Registration Data.
      <br />
      <strong>j. Survival of Paragraph.</strong>
      The provisions of Paragraph 8, subject to any future modifications, will
      survive these Terms of Use and your use of the Site. No amendment to
      Paragraph 8 shall apply to a dispute of which Whale Member had actual
      notice on the date of amendment.
      <br />
    </p>
    <h3>9. Limitation of Liability</h3>
    <p>
      <strong>a.</strong>
      YOU EXPRESSLY UNDERSTAND AND AGREE THAT YOUR USE OF THE SITE SHALL BE AT
      YOUR SOLE RISK AND THAT THE SITE IS PROVIDED “AS IS” AND “AS AVAILABLE.”
      TO THE FULLEST EXTENT PERMITTED BY LAW, WHALE MEMBER, ITS OWNERS,
      OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS DISCLAIM ALL WARRANTIES
      (EXPRESS OR IMPLIED) IN CONNECTION WITH THE SITE AND YOUR USE OF THE SITE.
      WHALE MEMBER MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR
      COMPLETENESS OF THE SITE’S CONTENTS OR THE CONTENT OF ANY SITE LINKED TO
      THE SITE.
      <br />
      <strong>b.</strong>
      IN NO EVENT SHALL WHALE MEMBER, ITS OWNERS, OFFICERS, DIRECTORS,
      EMPLOYEES, OR AGENTS BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT,
      INCIDENTAL, SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES WHATSOEVER
      RESULTING FROM: (i) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT; (ii)
      PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING
      FROM YOUR ACCESS TO AND USE OF THE SITE; (iii) ANY UNAUTHORIZED ACCESS TO
      OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION
      AND/OR FINANCIAL INFORMATION STORED THEREIN, EXCEPT AS OTHERWISE SET FORTH
      IN THESE TERMS OF USE; (iv) ANY INTERRUPTION OR CESSATION OF TRANSMISSION
      TO OR FROM THE SITE; (v) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE
      WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY; (vi)
      ANY CONDUCT (WHETHER ONLINE OR OFFLINE) BY ANY OTHER USER OF THE SITE;
      and/or (vii) ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR
      DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED,
      EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE ON THE SITE, WHETHER
      BASED ON WARRANTY, CONTRACT, TORT, OR ANY OTHER LEGAL AUTHORITY, AND
      WHETHER OR NOT YOU ARE ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
      <br />
      <strong>c.</strong>
      THE FOREGOING LIMITATION OF LIABILITY CONTAINED IN PARAGRAPH 9(b) SHALL
      APPLY TO THE FULLEST EXTENT PERMITTED BY LAW IN THE APPLICABLE
      JURISDICTION.
      <br />
      <strong>d.</strong>
      WHALE MEMBER DOES NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME
      RESPONSIBILITY FOR ANY PRODUCT OFFERED BY OR ADVERTISED BY ANY THIRD PARTY
      ON THE SITE OR HYPERLINKED ON THE SITE OR FEATURED IN ANY BANNER
      ADVERTISEMENT OR OTHER ADVERTISING. WHALE MEMBER WILL NOT BE A PARTY TO,
      OR IN ANY WAY RESPONSIBLE FOR, MONITORING ANY TRANSACTION BETWEEN YOU AND
      THIRD PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF ANY
      PRODUCT OR SERVICE IN ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE
      YOUR BEST JUDGMENT AND EXERCISE CAUTION WHEN APPROPRIATE.
      <br />
      <strong>e.</strong>
      YOU SPECIFICALLY ACKNOWLEDGE THAT WHALE MEMBER SHALL NOT BE LIABLE FOR
      USER SUBMISSIONS OR THE DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT OF ANY
      THIRD PARTY AND THAT RISK OF HARM OR DAMAGE FROM THE FOREGOING RESTS
      SOLELY WITH YOU.
      <br />
      <strong>f.</strong>
      WHALE MEMBER MAKES NO REPRESENTATION THAT THE SITE IS APPROPRIATE OR
      AVAILABLE FOR USE OUTSIDE OF THE UNITED STATES OF AMERICA. THOSE WHO
      ACCESS OR USE THE SITE FROM OTHER JURISDICTIONS DO SO AT THEIR OWN
      VOLITION AND ARE RESPONSIBLE FOR COMPLIANCE WITH LOCAL LAWS.
      <br />
      <strong>g.</strong>
      EXCEPT IN JURISDICTIONS WHERE LIMITATION OF LIABILITY PROVISIONS ARE NOT
      ENFORCEABLE FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES, WHALE MEMBER’S
      MAXIMUM LIABILITY TO YOU SHALL BE LIMITED TO THE FEES PAID BY YOU FOR A
      PERIOD OF NO MORE THAN 1 MONTH FROM THE ACCRUAL OF THE APPLICABLE CAUSE OF
      ACTION.
      <br />
    </p>
    <h3>10. Indemnification</h3>
    <p>
      You agree to defend and indemnify Whale Member, its officers, directors,
      employees, or agents should your actions harm any third party or if Whale
      Member is forced to defend itself from any civil or criminal action
      brought be a third party related to your actions. This includes any action
      brought by someone who was offended by the Content on the Site. This
      includes damages that are directly, indirectly, or consequentially related
      to your actions. If such a situation occurs, WM will inform you via the
      email address you provided in your Registration Data within 7 days of
      learning of the situation. Whale Member reserves the right to engage in
      its own defense and retain its own counsel in the event such a situation
      arises.
    </p>
    <br />
    <h3>11. Disclaimers</h3>
    <p>
      <strong>a.</strong>
      WM reserves the right to terminate your license and membership immediately
      if it has reason to suspect that you have used the Site or the Content in
      a manner which violates any law.
      <br />
      <strong>b.</strong>
      In the even that you use the Site or the Content in a manner that violates
      any law, WM may cooperate with law enforcement or the aggrieved parties.
      <br />
      <strong>c.</strong>
      There may be Content on the Site that you find offensive. In the event of
      such an occurrence, you agree to cease use of the Site immediately.
      <br />
    </p>
    <h3>12. Miscellaneous Provisions.</h3>
    <p>
      <strong>a. Severability.</strong>
      In the event that a court of competent jurisdiction or an arbitrator finds
      any provision of these Terms of Use, or any portion of any provision, to
      be invalid, the remainder of these Terms of Use shall continue in full
      force and effect.
      <br />
      <strong>b. Assignment.</strong>
      The obligations and rights conveyed pursuant to these Terms of Use shall
      inure to the benefit of the parties’ successors and assigns.
      <br />
      <strong>c. Headings.</strong>
      All headings in these Terms of Use are made solely for the sake of
      reference and convenience and shall not affect the interpretation of the
      terms of these Terms of Use.
      <br />
      <strong>d. Waiver.</strong>
      Any waiver by Whale Member of any term of these Terms of Use shall not be
      deemed a continuing waiver, and failure of Whale Member to assert a right
      or term shall not be deemed a waiver whereof.
      <br />
      <strong>e. Complete Agreement.</strong>
      These Terms of Use are the entire agreement between the parties with
      respect to your access and use of the Site and your license to view the
      Content. Any and all previous agreements are hereby superceded.
      <br />
    </p>
    <h3>13. Refund</h3>
    <p>
      If Whale Member terminates your rights to use the Whale Member license
      because you have breached this Agreement, you shall not be entitled to the
      refund of any unused portion of subscription fees.
    </p>
  </LayoutLegal>
</template>

<script setup>
  useSiteSeo({
    defaultTitle: "Terms of Use | {{ siteName }}",
    defaultDescription:
      "The following Terms of Use govern your access to and ...",
  })
</script>
